export enum McsisPolicy {
  DoctorRead,
  InsuranceRead,
  LocalityRead,
  MedicalDataEdit,
  MedicalDataRead,
  QuestionRead,
  UserRead,
}
